<template>
    <div style="background-color: white; padding: 10px 20px">
        <div v-if="showList">
            <div style="text-align: right">
                <v-btn dark round color="primary" @click="addToList">
                    <v-icon>add</v-icon>
                    Thêm giáo viên vào danh sách
                </v-btn>
                <v-btn dark round class="yoprimary" @click="addToClass">
                    <v-icon>add</v-icon>
                    Mời giáo viên vào lớp
                </v-btn>
            </div>
            <v-data-table :headers="teacherHeaders" :items="teachers" class="elevation-1 gru-table fixed-header"
                          :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination">
                <template slot="headers">
                    <tr>
                        <th v-for="header in teacherHeaders" :width="header.width" :class="[
                  header.sortable?'column sortable active':'',
                  (header.value == sortField && orderBy=='desc') ? 'desc' : 'asc'
                ]"
                            @click="changeSort(header)"
                        >
                            <div v-if="header.value=='checkbox'" style="text-align: center">
                                <v-checkbox color="primary" hide-details v-model="selectAll"></v-checkbox>
                            </div>
                            <div v-else :style="header.headerStyle">
                                {{$t(header.text)}}
                                <v-icon small class="no-print" v-if="header.sortable && header.value ==sortField">
                                    arrow_upward
                                </v-icon>
                            </div>
                        </th>
                    </tr>
                    <tr class="grey lighten-3 no-print filter">
                        <td v-for="header in teacherHeaders" class="text-xs-left gru-filter">
                            <div v-if="header.search==true" class="border-and-box">
                                <v-text-field single-line
                                              hide-details
                                              v-model.trim="teacher[header.value]"
                                              v-on:keyup.enter="init"
                                              dense
                                              :placeholder="'Tìm kiếm '+ header.text"
                                              type="text"
                                              small
                                              flat
                                />
                            </div>
                            <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                        </td>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.index+1 + parseInt(pagination.page-1) *
                        parseInt(pagination.rowsPerPage)}}
                    </td>
                    <td class="text-xs-left">
                        <v-btn @click="viewDetailOfTeacher(props.item.userId)" class="mx-0" icon
                               title="Thông tin giáo viên">
                            <i-avatar :user-id="props.item.userId"/>
                        </v-btn>
                        <!--i-avatar :user-id="props.item.userId" @click="viewDetailOfTeacher(props.item.userId)"/-->
                        <!--v-btn @click="viewTeacherInfo(props.item.teacherId)" class="mx-0" icon
                               title="Thông tin giáo viên">
                            <v-icon color="primary">account_circle</v-icon>
                        </v-btn-->
                        {{ props.item.teacherName }}
                    </td>
                    <td class="text-xs-left">{{ props.item.email }}</td>
                    <td class="text-xs-left">{{ props.item.phone }}</td>
                    <!--td class="text-xs-left">{{ getStatusName(props.item.status) }}</td-->
                    <td class="justify-center">
                        <v-btn @click="viewClassOfTeacher(props.item.teacherId)" class="mx-0" icon title="Danh sách lớp"
                               v-if="props.item.classes != null">
                            <v-icon color="primary">list_alt</v-icon>
                        </v-btn>
                    </td>
                    <td>
                        <v-switch v-model="props.item.status" label="On" @change="changeStatus(props.item)"/>
                    </td>
                    <td>
                        <v-btn @click="deleteTeacher(props.item.teacherId)" class="mx-0" icon title="Xóa khỏi danh sách"
                               v-if="props.item.status == 0">
                            <v-icon color="pink">delete</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>
        </div>
        <div v-else class="yocontent">
            <member-detail :editing-member="editingMember" :user="editingUser" :view-type="viewType" @cancel="showList=true"/>
        </div>
        <v-dialog max-width="900px" v-model="sDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline"
                         style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 1px solid gray">
                        <v-btn @click="sDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Thêm giáo viên vào danh sách
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <div v-if="step==0">
                                    <div style="margin-bottom: 10px;margin-top: -20px">Nhập thông tin giáo viên sẽ thêm
                                        vào
                                        Danh sách
                                    </div>
                                    <div style="max-height: 400px;overflow-y: auto">
                                        <v-form @keyup.enter.native="enterInList">
                                            <v-data-table :headers="addTeacherHeaders" :items="lstInsertTeacher"
                                                          class="elevation-1" hide-actions>
                                                <template slot="items" slot-scope="props">
                                                    <td class="text-xs-center">{{props.index + 1}}</td>
                                                    <td class="text-xs-left">
                                                        <input class="tableInput" :id="'teacherName_'+props.index"
                                                               :row="props.index" :col="0"
                                                               v-model="props.item.teacherName"/>
                                                        <div class="error--text">{{err.fullName[props.index]}}</div>
                                                    </td>
                                                    <td class="text-xs-left">
                                                        <input class="tableInput" v-model="props.item.email"
                                                               @change="getTeacherInfo(props.item,props.index)"
                                                               :id="'email_'+props.index" :row="props.index" :col="1"/>
                                                        <div class="error--text">{{err.email[props.index]}}</div>
                                                    </td>
                                                    <td class="text-xs-left">
                                                        <input class="tableInput" v-model="props.item.phone"
                                                               @change="getTeacherInfo(props.item,props.index)"
                                                               :id="'phone_'+props.index" :row="props.index" :col="2"/>
                                                        <div class="error--text">{{err.phone[props.index]}}</div>
                                                    </td>
                                                    <td class="justify-center">
                                                        <v-btn @click="removeInsertTeacher(props.index)"
                                                               class="mx-0" icon>
                                                            <v-icon color="pink">delete</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>
                                            </v-data-table>
                                        </v-form>
                                    </div>
                                    <v-btn flat @click="pushEmptyTeacher" class="primaryColor">
                                        <v-icon>add</v-icon>
                                        Thêm dòng
                                    </v-btn>
                                </div>
                                <div v-else-if="step==1">
                                    <div class="header_info">Thông tin {{lstInsertTeacher.length}} tài khoản bạn vừa
                                        nhập:
                                    </div>
                                    <div class="header_info" v-if="numberOfExist()>0">- {{numberOfExist()}} tài khoản
                                        của GV đã có trong danh sách
                                    </div>
                                    <!--div class="header_info">- {{numberOfStudent()}} là tài khoản Học viên, không thêm được vào danh sách giáo viên
                                    </div-->
                                    <div class="header_info">- {{numberOfAdd()}} tài khoản sẽ thêm vào danh sách giáo
                                        viên?
                                    </div>
                                    <v-data-table :headers="addTeacherConfirmHeaders" :items="lstInsertTeacher"

                                                  class="elevation-1" hide-actions key="verifyAccountTable">
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-center">{{props.index+1}}</td>
                                            <td class="text-xs-left">
                                                {{props.item.teacherName}}
                                            </td>
                                            <td class="text-xs-left">
                                                {{props.item.email}}
                                            </td>
                                            <td class="text-xs-left">
                                                {{props.item.phone}}
                                            </td>
                                            <td class="text-xs-left">
                                                {{getAccountStatus(props.item)}}
                                            </td>
                                            <td class="justify-center">
                                                {{getActionNameInList(props.item)}}
                                                <input class="tableInput" type="checkbox"
                                                       v-model="props.item.selected"
                                                       v-if="props.item.status == 0"/>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </div>
                                <div v-else-if="step==2">
                                    <div class="header_info">Bạn đã thêm {{addSuccess}} Giáo viên vào danh sách.</div>
                                    <div class="header_info">{{numberOfCreate()}} Giáo viên chưa có tài khoản Yoclass.
                                        Bạn sẽ tạo tài khoản Yoclass cho Giáo viên?
                                    </div>
                                    <v-data-table :headers="teacherCreateHeaders" :items="lstInsertTeacher"
                                                  key="createAccountTable"
                                                  class="elevation-1" hide-actions>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.index+1 }}</td>
                                            <td class="text-xs-left">{{ props.item.teacherName }}</td>
                                            <td class="text-xs-left">{{ getUserName(props.item) }}</td>
                                            <td class="text-xs-left">
                                                <input :key="'create_'+props.item.teacherId" class="tableInput"
                                                       v-model="props.item.password"/>
                                                <div class="error--text">{{err.password[props.index]}}</div>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </div>
                                <div v-else-if="step==3" class="result_info">
                                    <div>Bạn đã tạo tài khoản Yoclass cho {{createdSuccess}} giáo viên <br/>
                                        Thông tin tài khoản và mật khẩu đăng nhập Yoclass.vn
                                        sẽ được gửi tới giáo viên theo email/số điện thoại vừa tạo.
                                    </div>
                                    <div> {{createdSuccess}} Giáo viên này sẽ được thêm vào danh sách</div>
                                </div>
                                <div v-else class="result_info">
                                    <div>Bạn đã hoàn thành thêm giáo viên vào danh sách.
                                    </div>
                                </div>

                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="onCheckAccount" class="yoprimary" v-if="step==0" dark>Tiếp tục</v-btn>
                    <v-btn @click.native="onAddToList" class="yoprimary" v-else-if="step==1" dark>Tiếp tục</v-btn>
                    <v-btn @click.native="onCreateAccount" class="yoprimary" v-else-if="step==2" dark>Tạo tài khoản
                    </v-btn>
                    <v-btn @click.native="sDialog=false" class="yoprimary" v-else dark>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="800px" v-model="scDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline"
                         style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 1px solid gray">
                        <v-btn @click="scDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Danh sách lớp của giáo viên
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <v-data-table key="select_class" :headers="teacherClassHeader" :items="lstClass"
                                              v-if="step==0"
                                              :rows-per-page-items="rowsPerPageItems"
                                              class="elevation-1">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{props.item.className}}
                                        </td>
                                        <td class="text-xs-center">
                                            <v-btn @click="deleteTeacherClass(props.item.classId)" class="mx-0" icon
                                                   title="Giáo viên rời lớp">
                                                <v-icon color="pink">delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="scDialog=false" v-if="step==0" color="cancel" dark>
                        {{$t("lang.common.close")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="800px" v-model="cDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline dialog-header">
                        <v-btn @click="cDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Mời giáo viên vào lớp
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <div v-if="step==0">Chọn lớp:</div>
                                <div v-if="step==1">Chọn giáo viên:</div>
                                <v-data-table :headers="classHeader" :items="lstClass" v-if="step==0"
                                              :rows-per-page-items="rowsPerPageItems"
                                              class="elevation-1">
                                    <template slot="headers">
                                        <tr>
                                            <th v-for="header in classHeader" :width="header.width"
                                            >
                                                <div v-if="header.value=='checkbox'" style="text-align: center">
                                                    <v-checkbox color="primary" hide-details
                                                                v-model="selectAll"></v-checkbox>
                                                </div>
                                                <div v-else :style="header.headerStyle">
                                                    {{$t(header.text)}}
                                                    <v-icon small class="no-print"
                                                            v-if="header.sortable && header.value ==sortField2">
                                                        arrow_upward
                                                    </v-icon>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr class="grey lighten-3 no-print filter">
                                            <td v-for="header in classHeader" class="text-xs-left gru-filter">
                                                <div v-if="header.search==true" class="border-and-box">
                                                    <v-text-field single-line
                                                                  hide-details
                                                                  v-model.trim="search"
                                                                  v-on:keyup.enter="getClass"
                                                                  :placeholder="'Tìm kiếm '+ header.text"
                                                                  dense
                                                                  type="text"
                                                                  small
                                                    />
                                                </div>
                                                <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-center">{{props.index+1}}
                                        </td>
                                        <td class="text-xs-left">{{props.item.className}}
                                        </td>
                                        <td class="text-xs-center">
                                            <input :key="props.item.classId" class="tableInput" type="checkbox"
                                                   :value="true" v-model="props.item.selected"
                                                   @change="changeSelectClass(props.item)"/>
                                        </td>
                                    </template>
                                </v-data-table>
                                <v-data-table key="select_teacher" :headers="teacherSelectHeaders"
                                              :rows-per-page-items="rowsPerPageItems"
                                              :items="lstSelectTeacher" v-else-if="step==1"
                                              :pagination.sync="pagination2"
                                              class="elevation-1 gru-table fixed-header">
                                    <template slot="headers">
                                        <tr>
                                            <th v-for="header in teacherSelectHeaders" :width="header.width" :class="[
                  header.sortable?'column sortable active':'',
                  (header.value == sortField2 && orderBy2=='desc') ? 'desc' : 'asc'
                ]"
                                                @click="changeSort2(header)"
                                            >
                                                <div v-if="header.value=='checkbox'" style="text-align: center">
                                                    <v-checkbox color="primary" hide-details
                                                                v-model="selectAll"></v-checkbox>
                                                </div>
                                                <div v-else :style="header.headerStyle">
                                                    {{$t(header.text)}}
                                                    <v-icon small class="no-print"
                                                            v-if="header.sortable && header.value ==sortField2">
                                                        arrow_upward
                                                    </v-icon>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr class="grey lighten-3 no-print filter">
                                            <td v-for="header in teacherSelectHeaders" class="text-xs-left gru-filter">
                                                <div v-if="header.search==true" class="border-and-box">
                                                    <v-text-field single-line
                                                                  hide-details
                                                                  v-model.trim="teacher2[header.value]"
                                                                  v-on:keyup.enter="searchTeacher2"
                                                                  :placeholder="'Tìm kiếm '+ header.text"
                                                                  dense
                                                                  type="text"
                                                                  small
                                                    />
                                                </div>
                                                <v-icon v-else-if="header.value=='checkbox'">filter_list</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{ props.index+1 + parseInt(pagination2.page-1) *
                                            parseInt(pagination2.rowsPerPage) }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.teacherName }}</td>
                                        <td class="text-xs-left">{{ props.item.email }}</td>
                                        <td class="text-xs-left">{{ props.item.phone }}</td>
                                        <td class="justify-center">
                                            <input :key="props.item.studentId" :row="props.index" class="tableInput"
                                                   type="checkbox"
                                                   v-model="props.item.selected" @change="changeSelect(props.item)"/>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="onSelectClass" v-if="step==0" class="yoprimary" dark>Chọn lớp</v-btn>
                    <v-btn @click.native="onAddToClass" v-else class="yoprimary" dark>Mời vào lớp</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--v-dialog max-width="600px" v-model="uDialog" persistent>
            <v-card>
                <v-card-title>
                    <div class="headline"
                         style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 1px solid gray">
                        <v-btn @click="uDialog=false" icon style="float: left">
                            <v-icon>close</v-icon>
                        </v-btn>
                        Thêm học viên vào lớp
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xm12 md12 sm12 lg12 xs12>
                                <v-data-table key="select_class" :headers="classHeader" :items="lstClass" v-if="step==0"
                                              :rows-per-page-items="rowsPerPageItems"
                                              class="elevation-1">
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{props.item.className}}
                                        </td>
                                        <td class="text-xs-center"><input :key="props.item.classId" class="tableInput"
                                                                          type="checkbox"
                                                                          v-model="props.item.selected"/>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="onAddToClass" v-if="step==0" class="yoprimary" dark>Chọn lớp</v-btn>
                    <v-btn @click.native="onInsertToClass" v-else-if="step==1" class="yoprimary" dark>Thêm vào lớp
                    </v-btn>
                    <v-btn @click.native="onInsertToClass" v-else class="yoprimary" dark>Tạo tài khoản</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog-->
    </div>
</template>

<script>
    import axios from "axios";
    import {CrudService} from "@/services";
    import {message} from "@/shared/message";
    import Validator from "../../../public/js/validator";
    import MemberDetail from "../class/memberDetail";

    const v = Validator();

    export default {
        name: "teacher-component",
        components: {MemberDetail},
        props: {
            exerciseType: {
                type: String | Number,
                default: null
            },
            value: {
                type: Boolean,
                default: false
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            viewType:"teacher",
            editingMember: null,
            editingUser: null,
            showList:true,
            step: 0,
            sortField: "teacherName",
            orderBy: "asc",
            sortField2: "teacherName",
            orderBy2: "asc",
            sDialog: false,
            cDialog: false,
            scDialog: false,
            uDialog: false,
            teacherHeaders: [
                {
                    text: "STT",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "teacherName",
                    width: "20%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "email",
                    width: "15%"
                },
                {
                    text: "SĐT",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "phone",
                    width: "15%"
                },
                {
                    text: "Lớp học",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "teacherId",
                    width: "20%"
                },
                {
                    text: "Trạng thái",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "teacherId",
                    width: "20%"
                },
                {
                    text: "Xóa",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "studentId",
                    width: "20%"
                }
            ],
            addTeacherHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "SĐT",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "20%"
                },
                {
                    text: "Xử lý",
                    value: "name",
                    align: "center",
                    sortable: false,
                    width: "15%"
                }
            ],
            addTeacherConfirmHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "Số điện thoại",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                },
                {
                    text: "Tài khoản YOCLASS",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                },
                {
                    text: "Hành động",
                    value: "name",
                    align: "center",
                    sortable: false,
                    width: "10%"
                }
            ],
            teacherCreateHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Tên người dùng (Username)",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "Mật khẩu",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                }
            ],
            teacherSelectHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "teacherName",
                    width: "25%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "SĐT",
                    align: "left",
                    sortable: true,
                    search: true,
                    value: "phone",
                    width: "25%"
                },
                {
                    text: "Xử lý",
                    value: "name",
                    align: "left",
                    sortable: false,
                    width: "15%"
                }
            ],
            classHeader: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "classId"
                },
                {
                    text: "Lớp học",
                    align: "left",
                    sortable: false,
                    search: true,
                    value: "className"
                },
                {
                    text: "Chọn",
                    align: "center",
                    sortable: false,
                    value: "status"
                }
            ],
            teacherClassHeader: [
                {
                    text: "Lớp học",
                    align: "left",
                    sortable: false,
                    value: "className"
                },
                {
                    text: "Xử lý",
                    align: "center",
                    sortable: false,
                    value: "status"
                }
            ],
            createdSuccess: 0,
            addSuccess: 0,
            teachers: [],
            teacher: {},
            teacher2: {status: 1},
            lstInsertTeacher: [],
            lstSelectTeacher: [],
            lstClass: [],
            lstTeacherClass: [],
            search: "",
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
                orderBy: 'teacherName',
                descending: false
            },
            pagination2: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
                orderBy: 'teacherName',
                descending: false
            },
        }),

        watch: {
            value(val) {
                this.sDialog = val;
                this.init();
            },
            sDialog(val) {
                if (val == false) {
                    this.init();
                }
            },

            scDialog(val) {
                if (val == false) {
                    this.init();
                }
            }

        },

        created() {
            //this.init();
            //this.getClass();
        },
        methods: {
            getUserName: function (teacher) {
                if (teacher.email != null && teacher.email != "") {
                    return teacher.email;
                } else {
                    return teacher.phone;
                }
            },

            getTeacherInfo(item, index) {
                let url = process.env.VUE_APP_API_URL + "/school/teacher";
                axios
                    .post(url, item)
                    .then(
                        data => {
                            if (data == null || data == "") {

                            } else {
                                item = data;
                                if(item.userId != null && (item.teacherId == null || item.teacherId == 0)){
                                    message.error("Thông tin tài khoản bạn vừa nhập trùng với tài khoản học viên nên không thể đưa vào danh sách");
                                    item['email'] = "";
                                    item["phone"] = "";
                                    item["teacherName"] = "";
                                    this.lstInsertTeacher.splice(index, 1,item);
                                    document.getElementById("teacherName_" + index).focus();
                                } else {
                                    document.getElementById("email_" + index).disabled = true;
                                    document.getElementById("phone_" + index).disabled = true;
                                    document.getElementById("teacherName_" + index).disabled = true;
                                    this.lstInsertTeacher.splice(index, 1, item);
                                }
                                //let newarr = this.lstInsertStudent;
                                //newarr[index] =  item;
                                //console.log(this.lstInsertStudent);
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            disableExistItem() {
                for (let i = 0; i < this.lstInsertTeacher.length; i++) {
                    let disabled = false;
                    if (this.lstInsertTeacher[i].userId > 0) {
                        disabled = true;
                    }
                    document.getElementById("email_" + i).disabled = disabled;
                    document.getElementById("phone_" + i).disabled = disabled;
                    document.getElementById("teacherName_" + i).disabled = disabled;
                }
            },

            enterInList: function (e) {
                console.log(e);
                let row = parseInt(e.target.getAttribute("row"));
                let col = parseInt(e.target.getAttribute("col"));
                console.log(row + "-" + col);
                let next = "";
                if (col < 2) {
                    if (col == 0) {
                        next = "email_" + row;
                    } else {
                        next = "phone_" + row;
                    }
                    document.getElementById(next).focus();
                } else {
                    console.log(row + "-")
                    if (row == this.lstInsertTeacher.length - 1) {
                        this.pushEmptyTeacher();
                        this.$nextTick(() => {
                            row += 1;
                            next = "teacherName_" + row;
                            console.log(next);
                            document.getElementById(next).focus();
                        })
                    } else {
                        row += 1;
                        next = "teacherName_" + row;
                        console.log(next);
                        document.getElementById(next).focus();
                    }
                }
            },

            changeSort2: function (header) {
                if (!header.sortable) {
                    return;
                }
                let descending = true;
                if (this.sortField2 == header.value) {
                    if (this.orderBy2 == "asc") {
                        this.orderBy2 = "desc";
                    } else {
                        this.orderBy2 = "asc";
                        descending = false;
                    }
                } else {
                    this.sortField2 = header.value;
                    this.orderBy2 = "asc";
                    descending = false;
                }
                this.pagination2 = {
                    rowsPerPage: 10,
                    page: 1,
                    orderBy: header.value,
                    descending: descending
                };

                this.searchTeacher2();
            },

            changeSort: function (header) {
                if (!header.sortable) {
                    return;
                }
                let descending = true;
                if (this.sortField == header.value) {
                    if (this.orderBy == "asc") {
                        this.orderBy = "desc";
                    } else {
                        this.orderBy = "asc";
                        descending = false;
                    }
                } else {
                    this.sortField = header.value;
                    this.orderBy = "asc";
                    descending = false;
                }
                this.pagination = {
                    rowsPerPage: 10,
                    page: 1,
                    orderBy: header.value,
                    descending: descending
                };
                console.log(this.pagination);

                this.init();
            },

            getAccountStatus: function (item) {
                if (item.userId == null || item.userId == 0) {
                    return "Chưa có";
                } else {
                    return "Đã có";
                }
            },

            getStatusName(status) {
                if (status == 0) {
                    return "Chưa phê duyệt";
                } else if (status == 1) {
                    return "Đã phê duyệt"
                } else if (status == -1) {
                    return "Đã rời"
                } else {
                    return "";
                }
            },

            init() {
                let url = process.env.VUE_APP_API_URL + "/school/teachers?";
                if (this.sortField != null) {
                    url += "orderBy=" + this.sortField;
                    if (this.orderBy != null) {
                        url += "&sort=" + this.orderBy;
                    }
                }
                axios
                    .post(url, this.teacher)
                    .then(
                        data => {
                            this.teachers = data;
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            searchTeacher2() {
                let url = process.env.VUE_APP_API_URL + "/school/teachers?";
                if (this.sortField2 != null) {
                    url += "orderBy=" + this.sortField2;
                    if (this.orderBy2 != null) {
                        url += "&sort=" + this.orderBy2;
                    }
                }
                axios
                    .post(url, this.teacher2)
                    .then(
                        data => {
                            this.lstSelectTeacher = data;
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            getClass() {
                let url = process.env.VUE_APP_API_URL + "/class/myclass?";
                if (this.search != null && this.search != "") {
                    url += "search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.lstClass = data;
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            getEmptyClass() {
                let url = process.env.VUE_APP_API_URL + "/class/myEmptyclass?";
                if (this.search != null && this.search != "") {
                    url += "search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.lstClass = data;
                    },
                    error => {
                        console.log(error);
                    }
                )
            },

            pushEmptyTeacher() {
                this.lstInsertTeacher.push({
                    "teacherName": "",
                    "email": "",
                    "phone": ""
                })
                this.err.fullName.push("");
                this.err.email.push("");
                this.err.phone.push("");
                this.$nextTick(() => {
                    this.disableExistItem();
                })
            },

            onCheckAccount() {
                if (this.lstInsertTeacher.length == 0) {
                    message.error("Bạn chưa nhập thông tin giáo viên");
                    return;
                }
                this.err = {
                    fullName: Array(this.lstInsertTeacher.length).fill(""),
                    email: Array(this.lstInsertTeacher.length).fill(""),
                    phone: Array(this.lstInsertTeacher.length).fill(""),
                    password:Array(this.lstInsertTeacher.length).fill("")
                }
                let validate = true;
                for (let i = 0; i < this.lstInsertTeacher.length; i++) {
                    if (this.lstInsertTeacher[i].teacherName == null || this.lstInsertTeacher[i].teacherName.trim().length == 0) {
                        this.err.fullName[i] = "Không được phép để trống";
                        validate = false;
                    }
                    if ((this.lstInsertTeacher[i].email != null && this.lstInsertTeacher[i].email.trim().length > 0)) {
                        if (!v.validateEmail(this.lstInsertTeacher[i].email)) {
                            this.err.email[i] = "Không đúng định dạng email";
                            validate = false;
                        }
                    } else {
                        this.err.email[i] = "Email không được để trống";
                        validate = false;
                    }

                    if ((this.lstInsertTeacher[i].phone != null && this.lstInsertTeacher[i].phone.trim().length > 0)) {
                        if (!v.validatePhone(this.lstInsertTeacher[i].phone)) {
                            this.err.phone[i] = "Không đúng định dạng số điện thoại";
                            validate = false;
                        }
                    } else {
                        this.err.phone[i] = "Số điện thoại không được để trống ";
                        validate = false;
                    }

                }
                if (!validate) {
                    return;
                }
                let url = process.env.VUE_APP_API_URL + "/school/checkMembers";
                axios
                    .post(url, this.lstInsertTeacher)
                    .then(
                        data => {
                            for (let i = 0; i < data.length; i++) {
                                if (data[i].status == 0 || data[i].status == null) {
                                    data[i].selected = true;
                                } else {
                                    data[i].selected = true;
                                }
                            }
                            this.lstInsertTeacher = data;
                            this.step = 1;
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            addToList() {
                this.sDialog = true;
                this.lstInsertTeacher = [];
                this.step = 0;
                this.err.fullName = [];
                this.err.email = [];
                this.err.phone = [];
                this.pushEmptyTeacher();
            },

            getActionNameInList(item) {
                if (item.userId != undefined && item.userId != null && item.userId != "") {
                    if (item.status == 1) {
                        return "Đã có trong danh sách";
                    } else {
                        return "Thêm vào danh sách";
                    }
                } else {
                    return "Tạo tài khoản";
                }
            },

            onAddToList() {
                let lstInsert = [];
                //
                // chi nhung giao vien da co tai khoan moi duoc them vao
                //
                for (let i = 0; i < this.lstInsertTeacher.length; i++) {
                    if (this.lstInsertTeacher[i].selected && this.lstInsertTeacher[i].status == 0 &&  this.lstInsertTeacher[i].userId != null) {
                        lstInsert.push(this.lstInsertTeacher[i]);
                    }
                }
                let url = process.env.VUE_APP_API_URL + "/school/addTeachers?";
                //
                // ko co du lieu day len thi xu ly buoc tiep theo luon
                //
                if (lstInsert.length == 0) {
                    for (let i = this.lstInsertTeacher.length - 1; i >= 0; i--) {
                        if (!this.lstInsertTeacher[i].selected || this.lstInsertTeacher[i].userId != null) {
                            this.lstInsertTeacher.splice(i, 1);
                        }
                    }
                    if (this.lstInsertTeacher.length > 0) {
                        this.err = {
                            fullName: Array(this.lstInsertTeacher.length).fill(""),
                            email: Array(this.lstInsertTeacher.length).fill(""),
                            phone: Array(this.lstInsertTeacher.length).fill(""),
                            password:Array(this.lstInsertTeacher.length).fill(""),
                        }
                        this.step = 2;
                    } else {
                        this.step = 4;
                    }
                    return;
                }
                axios
                    .post(url, lstInsert)
                    .then(
                        data => {
                            if (data.success) {
                                this.addSuccess = data.ref.successCount;
                                if (this.addSuccess == this.lstInsertTeacher.length) {
                                    this.step = 4;
                                } else {
                                    for (let i = this.lstInsertTeacher.length - 1; i >= 0; i--) {
                                        if (!this.lstInsertTeacher[i].selected || this.lstInsertTeacher[i].userId != null) {
                                            this.lstInsertTeacher.splice(i, 1);
                                        }
                                    }
                                    if (this.lstInsertTeacher.length > 0) {
                                        this.err = {
                                            fullName: Array(this.lstInsertTeacher.length).fill(""),
                                            email: Array(this.lstInsertTeacher.length).fill(""),
                                            phone: Array(this.lstInsertTeacher.length).fill(""),
                                            password:Array(this.lstInsertTeacher.length).fill(""),
                                        }
                                        this.step = 2;
                                    } else {
                                        this.step = 4;
                                    }
                                }
                            } else {
                                message.error("Thêm mới không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            onCreateAccount() {
                this.err = {
                    fullName: Array(this.lstInsertTeacher.length).fill(""),
                    email: Array(this.lstInsertTeacher.length).fill(""),
                    phone: Array(this.lstInsertTeacher.length).fill(""),
                    password:Array(this.lstInsertTeacher.length).fill(""),
                }
                let validate =true;
                for (let i = 0; i < this.lstInsertTeacher.length; i++) {
                    if (this.lstInsertTeacher[i].password == null || this.lstInsertTeacher[i].password.trim().length == 0) {
                        this.err.password[i] = "Không được phép để trống";
                        validate = false;
                    } else if (this.lstInsertTeacher[i].password.trim().length <8){
                        this.err.password[i] = "Mật khẩu phải dài ít nhất 8 kí tự";
                        validate = false;
                    }
                }
                if(validate) {
                    let url = process.env.VUE_APP_API_URL + "/school/addTeachers?";
                    axios
                        .post(url, this.lstInsertTeacher)
                        .then(
                            data => {
                                if (data.success) {
                                    this.createdSuccess = parseInt(data.ref.successCount);
                                    this.step = 3;
                                } else {
                                    message.error(data.description);
                                }
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }
            },

            removeInsertTeacher(index) {
                this.lstInsertTeacher.splice(index, 1);
            },

            viewClassOfTeacher(teacherId) {
                this.step = 0;
                this.teacherId = teacherId;
                axios.post(process.env.VUE_APP_API_URL + "/school/teacherClass?teacherId=" + this.teacherId).then(
                    data => {
                        /*                        let classes = [];
                                                for (let i = 0; i < this.lstClass.length; i++) {
                                                    this.lstClass[i].selected = false;
                                                    if (data != null && data != "") {
                                                        for (let j = 0; j < data.length; j++) {
                                                            if (data[j].classId == this.lstClass[i].classId) {
                                                                this.lstClass[i].selected = true;
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    classes.push(this.lstClass[i]);
                                                }*/
                        this.lstClass = data;
                        console.log(this.lstClass);
                        this.scDialog = true;
                    },
                    error => {

                    }
                )
            },

            changeStatus(item) {
                let cf, status;
                if (item.status) {
                    cf = confirm("Bạn có chắc muốn mở khóa giáo viên?");
                    status = 1;
                } else {
                    cf = confirm("Bạn có chắc muốn khóa giáo viên?");
                    status = 0;
                }
                if (!cf) {
                    item.status = !item.status;
                } else {
                    axios
                        .post(process.env.VUE_APP_API_URL + "/school/changeTeacherStatus?teacherId=" + item.teacherId + "&status=" + status)
                        .then(
                            data => {
                                if (data.success) {
                                    if (item.status) {
                                        message.success("Mở khóa giáo viên thành công");
                                    } else {
                                        message.success("Khóa giáo viên thành công");
                                    }
                                    this.init();
                                } else {
                                    message.error("Xóa không thành công");
                                }
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }

            },

            deleteTeacher(id) {
                let cf = confirm("Bạn có chắc muốn xóa giáo viên khỏi danh sách?");
                if (!cf) {
                    return;
                }
                axios
                    .post(process.env.VUE_APP_API_URL + "/school/deleteTeacher?teacherId=" + id)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Xóa giáo viên thành công");
                                this.init();
                            } else {
                                message.error("Xóa không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            deleteTeacherClass(classId) {
                let cf = confirm("Bạn có chắc rời giáo viên khỏi lớp?");
                if (!cf) {
                    return;
                }
                axios
                    .post(process.env.VUE_APP_API_URL + "/school/deleteTeacherClass?teacherId=" + this.teacherId + "&classId=" + classId)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Rời giáo viên thành công");
                                this.viewClassOfTeacher(this.teacherId);
                            } else {
                                message.error("Rời giáo viên không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            addToClass() {
                this.teacherId = null;
                this.cDialog = true;
                this.step = 0;
                this.getEmptyClass();
            },

            onSelectClass() {
                let insertItems = [];
                console.log(this.lstClass);
                for (let i = 0; i < this.lstClass.length; i++) {
                    if (this.lstClass[i].selected) {
                        insertItems.push(this.lstClass[i]);
                    }
                }
                if (insertItems.length == 0) {
                    message.error("Bạn chưa chọn lớp");
                    return;
                }
                if (this.teacherId != null) {
                    axios
                        .post(process.env.VUE_APP_API_URL + "/school/insertTeacherClass?teacherId=" + this.teacherId, insertItems)
                        .then(
                            data => {
                                if (data.success) {
                                    message.success("Thêm mới thành công");
                                    this.cDialog = false;
                                    this.init();
                                } else {
                                    message.error("Thêm mới không thành công");
                                }
                            },
                            error => {
                                message.error(error);
                            }
                        );
                } else {
                    this.step = 1;
                    this.searchTeacher2();
                }


            },

            onAddToClass() {
                let classIds = null;
                let insertClass = [];
                for (let i = 0; i < this.lstClass.length; i++) {
                    if (this.lstClass[i].selected) {
                        insertClass.push(this.lstClass[i]);
                        if (classIds == null) {
                            classIds = this.lstClass[i].classId;
                        } else {
                            classIds += "," + this.lstClass[i].classId;
                        }
                    }
                }
                let insertTeacher = [];
                let createTeacher = [];
                for (let i = 0; i < this.lstSelectTeacher.length; i++) {
                    if (this.lstSelectTeacher[i].selected) {
                        insertTeacher.push(this.lstSelectTeacher[i]);
                        if (this.lstSelectTeacher[i].userId == null || this.lstSelectTeacher[i].userId == 0) {
                            createTeacher.push(this.lstSelectTeacher[i]);
                        }
                    }
                }
                if (insertTeacher.length == 0 && insertTeacher.length == 0) {
                    message.error("Bạn chưa chọn giáo viên");
                    return;
                }

                axios
                    .post(process.env.VUE_APP_API_URL + "/school/inserMultiTeacherClass?classIds=" + classIds, insertTeacher)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Thêm mới thành công");
                                this.cDialog = false;
                                this.init();
                            } else {
                                message.error("Thêm mới không thành công");
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );

            },

            changeSelectClass(item) {
                //let row = e.target.getAttribute("row");
                console.log(item.selected);
                if (item.selected) {
                    let arr = [];
                    for (let i = 0; i < this.lstClass.length; i++) {
                        if (this.lstClass[i].classId == item.classId) {
                            //console.log("check:" + i);
                            this.lstClass[i].selected = true;
                        } else {
                            console.log("uncheck:" + i);
                            this.lstClass[i].selected = false;
                        }
                        arr.push(this.lstClass[i]);
                    }
                    this.lstClass = arr;
                }
            },

            changeSelect(item) {
                //let row = e.target.getAttribute("row");
                console.log(item.selected);
                if (item.selected) {
                    let arr = [];
                    for (let i = 0; i < this.lstSelectTeacher.length; i++) {
                        if (this.lstSelectTeacher[i].teacherId == item.teacherId) {
                            console.log("check:" + i);
                            this.lstSelectTeacher[i].selected = true;
                        } else {
                            console.log("uncheck:" + i);
                            this.lstSelectTeacher[i].selected = false;
                        }
                        arr.push(this.lstSelectTeacher[i]);
                    }
                    this.lstSelectTeacher = arr;
                }
            },

            numberOfExist: function () {
                let count = 0;
                for (let i = 0; i < this.lstInsertTeacher.length; i++) {
                    if (this.lstInsertTeacher[i].status == 1 && this.lstInsertTeacher[i].selected) {
                        count++;
                    }
                }
                return count;
            },

            numberOfAdd: function () {
                let total = this.lstInsertTeacher.length;
                let exist = this.numberOfExist();
                let remain = total - exist;
                return remain;
            },

            numberOfCreate: function () {
                let count = 0;
                console.log(this.lstInsertTeacher);
                for (let i = 0; i < this.lstInsertTeacher.length; i++) {
                    if (this.lstInsertTeacher[i].userId == null && this.lstInsertTeacher[i].selected) {
                        count++;
                    }
                }
                return count;
            },

            viewDetailOfTeacher(userId) {
                this.viewType = "teacher";
                CrudService.of('user').getItem(userId).then(user => {
                    this.editingMember = user;
                    this.editingUser = user;
                    this.showList= false;
                });
            }

        }
    };
</script>